/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".footer[_ngcontent-%COMP%] {\n  bottom: 0;\n  left: 0;\n  position: fixed;\n}"];
export { styles as styles };



// WEBPACK FOOTER //
// /Users/Chetan/Downloads/angular5_admin-master/src/app/app.component.css.shim.ngstyle.js.pre-build-optimizer.js